<template>
	<v-dialog
		v-model="visible"
		max-width="500"
		persistent
	>
		<v-alert
			class="mb-0 px-8"
			:border="'top'"
			colored-border
			color="info"
		>
			<v-row class="my-0">
				<div class="title-text">Change organiser</div>
			</v-row>
			<v-row class="my-0">
				<v-col cols="12" class="pa-0">
					<v-alert class="mt-4" type="error" dense v-if="error_msg.length !== 0">
						{{ error_msg }}
					</v-alert>
				</v-col>
			</v-row>
			<v-row class="mt-2">
				<v-autocomplete
					v-model="select"
					:loading="invitees_loading"
					:search-input.sync="invitees_search"
					:color="color"
					:items="items"
					item-text="employee.display_name"
					item-value="employee.id"
					item-color="success"
					item-disabled="disabled"
					placeholder="Type to search for Employee..."
					outlined
					dense
					return-object
					clearable
				>
					<template v-slot:item="{item, on}">
						<v-list-item dense>
							<v-row align-self="center" class="mt-0" v-on="on">
								<v-col :cols="$vuetify.breakpoint.mdAndDown ? 2: 1">
									<v-user-avatar
										size="24"
										class="text-caption text-decoration-none"
										:code="formatName(item.employee.display_name)"
										:image="`${item.uri}/image.png`"
									/>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.mdAndDown ? 9: 11" class="pr-0">
									<div class="item-text">{{ formatName(item.employee.display_name) }}</div>
									<div class="item-text over-text" style="color: rgba(25, 42, 62, 0.7); font-size: 12px;">{{ item.employee.email }}</div>
								</v-col>
							</v-row>
						</v-list-item>
					</template>	
				</v-autocomplete>
			</v-row>
			<v-row class="mt-0 mb-2" justify="center">
				<v-btn outlined class="text-capitalize" @click="$emit('cancel')">Cancel</v-btn>
				<v-btn 
					depressed 
					:color="select? '#00AAFD': 'rgba(25, 42, 62, 0.15)'" 
					class="ml-2 white--text text-capitalize" 
					@click="$emit('submit', select)">
					<span>Change organiser</span>
				</v-btn>
			</v-row>
		</v-alert>
	</v-dialog>
</template>

<script>
const DescriptionLimit = 60;

const Accepted_Code = 1;

export default {
	name: 'OrganiserDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ''
		},
		sendEmail: {
			type: Boolean,
			default: false
		},
		contact: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			error_msg: '',
			invitees_loading: false,
			invitees_search: null,

			select: null,
			items: []
		}
	},
	created() {
	},
	watch: {
		invitees_search(val) {
			val && this.inviteesQuery(val);
		}
	},
	methods: {
		inviteesQuery(key) {
			this.invitees_loading = true;

			const params = [];
			params.push("name=" + encodeURIComponent(key));
			params.push("allow_all=" + false);
			params.push("find_employee=" + true);
			params.push("find_freelancer=" + true);

			let url = "/api/addressbook/email";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						const employee_list = [];

						data.forEach(employee => {
							const name = this.formatName(employee.name);
							const description = name.length > DescriptionLimit
								? name.slice(0, DescriptionLimit) + '...'
								: name;

							const obj = {
								id: 0,
								accepted: Accepted_Code,
								contact: null,
								employee: {
									id: employee.abook_id,
									contact_id: employee.contact_id ? employee.contact_id : null,
									code: employee.code,
									display_name: description,
									email: employee.email,
									send_email: this.sendEmail
								},
								image: `${employee.uri}/image.png`,
								uri: employee.uri
							};
							employee_list.push(obj);
						});            

						this.items = employee_list;	
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.invitees_loading = false
				});
		},
		formatName(name) {
			let display_name = '';

			if (name && name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
	}
}
</script>
<style lang="scss" scoped>
.title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #192A3E;
}
</style>